<div class="row" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/user-dashboard'">
      <i class="fas fa-fw fa-home me-2"></i>Home<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <a [routerLink]="'/admin/billing'">
      <i class="fas fa-fw fa-file-invoice-dollar me-2"></i>Billing Center<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <span class="c_bluedk"><i class="fas fa-fw fa-filter mx-2"></i>Billing Review Pivot Grid</span>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <!-- Changing Toolbar -->
    <div class="card my-2" *ngIf="!showDrill">
      <div class="card-header">
        Filters
      </div>
      <div class="card-body p-2">
          <div class="row">
            <div class="col-12 col-md-4">
              <label for="clientSelect" class="normal">Client:</label>
              <select id="clientSelect" [ngModel]="selectedClient" (ngModelChange)="onClientChange($event)" class="form-select form-select-sm">
                <option *ngFor="let c of clients" [value]="c">{{ c }}</option>
              </select>
            </div>
            <div class="col-12 col-md-4">
              <label *ngIf="!showDrill" for="yearSelect" class="normal">Year:</label>
              <select id="yearSelect" [ngModel]="selectedYear" (ngModelChange)="onYearChange($event)"
                       class="form-select form-select-sm">
                <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
              </select>
            </div>
            <div class="col-12 col-md-4">
              <label for="billableSelect" class="normal">Billable:</label>
              <select id="billableSelect" [ngModel]="billableFilter" (ngModelChange)="onBillableChange($event)"
                       class="form-select form-select-sm">
                <option [ngValue]="'all'">All</option>
                <option [ngValue]="'yes'">Yes</option>
                <option [ngValue]="'no'">No</option>
              </select>
            </div>
          </div>
        <button *ngIf="showDrill" (click)="backToMain()" style=" padding:6px 12px; cursor:pointer;">
          ⟵ Back to Summary
        </button>
        <span *ngIf="showDrill" style="margin-left:12px; font-weight:600;">
          {{ drillTitle }}
        </span>
      </div>
    </div>

    <!-- SQL Logger -->
    <div class="mb-2" style="height: 100px; overflow-y: auto; border: 1px solid #ccc; background: #f4f4f4; padding: 8px; font-family: monospace;">
      <div *ngFor="let log of activityLog" [style.color]="log.success ? 'green' : 'red'">
        <strong>{{ log.timestamp }}</strong>: {{ log.message }}
      </div>
    </div>

    <!-- Main Pivot/Summary Grid -->
    <div *ngIf="!showDrill" class="ag-theme-alpine grid-shell" style="height: 55vh; width: 100%;">
      <ag-grid-angular #agGrid class="ag-theme-alpine" style="width: 100%; height: 100%;" [gridOptions]="gridOptions"
                       [rowData]="rowData" [columnDefs]="columnDefs" [pivotMode]="true" [rowGroupPanelShow]="rowGroupPanelShow"
                       [animateRows]="true" [rowHeight]="28" [headerHeight]="32" [autoGroupColumnDef]="autoGroupColumnDef"
                       [singleClickEdit]="true" [stopEditingWhenCellsLoseFocus]="false" (gridReady)="onGridReady($event)"
                       (cellClicked)="onCellClicked($event)" [pinnedBottomRowData]="summaryPinnedBottom">
      </ag-grid-angular>
    </div>

    <!-- Drilldown Grid -->
    <div *ngIf="showDrill">
      <div class="ag-theme-alpine" style="height: 55vh; width: 100%;">
        <ag-grid-angular class="ag-theme-alpine" style="width: 100%; height: 100%;" [gridOptions]="gridOptions"
                         [rowData]="drillRows" [columnDefs]="drillCols" [pinnedBottomRowData]="drillPinnedBottom" [rowHeight]="28"
                         [headerHeight]="32" [singleClickEdit]="true" [stopEditingWhenCellsLoseFocus]="true"
                         (cellEditingStarted)="onCellEditingStarted($event)" (cellValueChanged)="onDrillCellValueChanged($event)">
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>







